export default "__VITE_ASSET__CwN0lZyS__"